import request from "@/utils/request";

export function getPageList(params) {
  return request({
    url: "/DataDict/GetPageList",
    method: "get",
    params
  });
}
export function update(data) {
  return request({
    url: "/DataDict/Edit",
    method: "post",
    data
  });
}
export function addParent(data) {
  return request({
    url: "/DataDict/AddParent",
    method: "post",
    data
  });
}
export function addChild(data) {
  return request({
    url: "/DataDict/AddChild",
    method: "post",
    data
  });
}
export function del(data) {
  return request({
    url: "/DataDict/Delete",
    method: "delete",
    data
  });
}
